import React, { useEffect, useState } from 'react';
import axios from 'axios';
import TeacherCard from '../components/TeacherCard/TeacherCard';
import './MeetTeachers.css';

/* =========================================================
   Homepage › Meet our teachers
   Only teachers who filled their public profile and the admin approved
   (Admin › Teacher profiles), and only when the admin turned the section on.
   The server sends nothing with fewer than 2 teachers, so the section just doesn't show.
   Phones: a swipe row (the next card peeks in). Computers: a grid, up to 4 per row.
   ========================================================= */
const API = process.env.REACT_APP_API_BASE_URL;

const MeetTeachers = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/api/public/teachers`)
      .then((res) => alive && setItems(res.data?.items || []))
      .catch(() => alive && setItems([]));
    return () => {
      alive = false;
    };
  }, []);

  if (items.length < 2) return null;

  return (
    <section className="rmmt" aria-labelledby="rmmt-title">
      <div className="rmmt-wrap">
        <p className="rmmt-kicker">Our team</p>
        <h2 id="rmmt-title" className="rmmt-title">
          Meet our teachers
        </h2>
        <p className="rmmt-sub">Real people who love tech and teaching kids, one to one.</p>
        <ul className={`rmmt-list ${items.length < 4 ? 'is-few' : ''}`}>
          {items.map((t) => (
            <TeacherCard key={t.name + (t.about || '')} t={t} as="li" />
          ))}
        </ul>
        {items.length > 1 && <p className="rmmt-swipe">Swipe to see all our teachers</p>}
      </div>
    </section>
  );
};

export default MeetTeachers;
